
export interface Level {
  id: number;
  name: string;
  description: string;
  words: string[];
  timeLimit: number;
  requiredScore: number;
  accuracyBonus: number;
}

export interface GameStats {
  score: number;
  combo: number;
  maxCombo: number;
  accuracy: number;
  totalChars: number;
  correctChars: number;
  wordsCompleted: number;
  wpm: number;
}

export interface GameState {
  currentLevel: number;
  unlockedLevels: number;
  currentWordIndex: number;
  currentCharIndex: number;
  isPlaying: boolean;
  isPaused: boolean;
  startTime: number;
  levelStartTime: number;
}

export const LEVELS: Level[] = [
  {
    id: 1,
    name: "入门训练",
    description: "基础字母练习",
    words: ["a", "s", "d", "f", "j", "k", "l", "as", "df", "jk", "asd", "fjk", "asd", "fgh"],
    timeLimit: 60,
    requiredScore: 500,
    accuracyBonus: 1.0
  },
  {
    id: 2,
    name: "手指热身",
    description: "简单单词",
    words: ["cat", "dog", "sun", "run", "fun", "big", "red", "bed", "hot", "top", "cup", "map"],
    timeLimit: 60,
    requiredScore: 800,
    accuracyBonus: 1.1
  },
  {
    id: 3,
    name: "基础词汇",
    description: "常用单词",
    words: ["apple", "house", "water", "music", "happy", "green", "table", "chair", "light", "phone", "paper", "pencil"],
    timeLimit: 60,
    requiredScore: 1200,
    accuracyBonus: 1.2
  },
  {
    id: 4,
    name: "词汇进阶",
    description: "较长单词",
    words: ["computer", "keyboard", "monitor", "software", "internet", "download", "upload", "network", "system", "program", "design", "develop"],
    timeLimit: 60,
    requiredScore: 1500,
    accuracyBonus: 1.3
  },
  {
    id: 5,
    name: "短语挑战",
    description: "常见短语",
    words: ["good morning", "thank you", "good night", "see you", "how are you", "nice to meet", "have fun", "take care", "best friend", "well done"],
    timeLimit: 90,
    requiredScore: 2000,
    accuracyBonus: 1.4
  },
  {
    id: 6,
    name: "编程入门",
    description: "编程关键词",
    words: ["function", "variable", "string", "number", "boolean", "array", "object", "return", "import", "export", "async", "await"],
    timeLimit: 60,
    requiredScore: 1800,
    accuracyBonus: 1.5
  },
  {
    id: 7,
    name: "代码大师",
    description: "代码片段",
    words: ["const data = []", "let count = 0", "if (true) {", "return null;", "async () => {", "import { } from", "export default", "class Name {", "extends Base", "implements Iface"],
    timeLimit: 90,
    requiredScore: 2500,
    accuracyBonus: 1.6
  },
  {
    id: 8,
    name: "句子训练",
    description: "完整句子",
    words: [
      "The quick brown fox",
      "jumps over the lazy dog",
      "A journey of a thousand miles",
      "begins with a single step",
      "Practice makes perfect",
      "Time flies when having fun",
      "Knowledge is power",
      "Actions speak louder than words"
    ],
    timeLimit: 120,
    requiredScore: 3000,
    accuracyBonus: 1.7
  },
  {
    id: 9,
    name: "技术文章",
    description: "技术术语",
    words: [
      "artificial intelligence",
      "machine learning algorithm",
      "neural network architecture",
      "blockchain technology",
      "cloud computing platform",
      "cybersecurity measures",
      "data science analytics",
      "virtual reality experience"
    ],
    timeLimit: 120,
    requiredScore: 3500,
    accuracyBonus: 1.8
  },
  {
    id: 10,
    name: "终极挑战",
    description: "混合终极挑战",
    words: [
      "The five boxing wizards jump quickly",
      "Pack my box with five dozen liquor jugs",
      "How vexingly quick daft zebras jump",
      "The quick onyx goblin jumps over the lazy dwarf",
      "Sphinx of black quartz judge my vow",
      "Two driven jocks help fax my big quiz",
      "Public junk dwarves hug my quartz fox",
      "Quick zephyrs blow vexing daft Jim"
    ],
    timeLimit: 180,
    requiredScore: 5000,
    accuracyBonus: 2.0
  }
];

export const GRADE_THRESHOLDS = {
  S: 95,
  A: 85,
  B: 70,
  C: 60,
  F: 0
};

export function getGrade(accuracy: number): string {
  if (accuracy >= GRADE_THRESHOLDS.S) return 'S';
  if (accuracy >= GRADE_THRESHOLDS.A) return 'A';
  if (accuracy >= GRADE_THRESHOLDS.B) return 'B';
  if (accuracy >= GRADE_THRESHOLDS.C) return 'C';
  return 'F';
}

export function calculateWPM(correctChars: number, timeMs: number): number {
  const minutes = timeMs / 60000;
  const words = correctChars / 5;
  return Math.round(words / minutes);
}
